module.exports = __webpack_public_path__ + "1c2e1cdea02e7dfab25424e6e42d7973.woff2";